module.exports = __webpack_public_path__ + "2f66c70bed6f87882dbedba82ac2845f.png";